<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ca5"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter()">
          查询
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :header-cell-class-name="headerCellClassName"
      :cell-class-name="cellClassName"
      show-footer
      :footer-method="footerMethod"
      :data="tableData"
      :checkbox-config="{ highlight: true }"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 项目名称 -->
      <vxe-table-column>
        <vxe-table-column
          field="projectName"
          title="项目名称"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.projectName"
            placeholder="请输入项目名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="companyName"
          title="托运人"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 经办人 -->
      <vxe-table-column>
        <vxe-table-column
          field="dfName"
          title="经办人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.dfName"
            placeholder="请输入经办人"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 运输单号 -->
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入运输单号"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人姓名"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车牌号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 实际承运人净得 -->
      <vxe-table-column>
        <vxe-table-column
          field="deliveryFeePractical"
          title="实际承运人净得运费"
          :formatter="formatterDriverNetFreight"
          min-width="160"
          sortable
        />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentDeliveryFeePractical"
          title="托运人应付运费"
          min-width="230"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- 异常类型 -->
      <vxe-table-column>
        <vxe-table-column
          field="appealType"
          title="异常类型"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.appealType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in appealTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 异常原因 -->
      <vxe-table-column>
        <vxe-table-column
          field="authorizeCause"
          title="异常原因"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.authorizeCause"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 状态 -->
      <vxe-table-column>
        <vxe-table-column
          field="appealStatus"
          title="状态"
          :formatter="formatAppealStatus"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.appealStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in appealStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 创建时间   <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreated"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>-->

      <!-- 更新时间 -->
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="更新时间"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <!-- <el-date-picker
            v-model="listQuery.gmtModified"
            type="datetime"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="optionsPickerEnd"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            default-time="23:59:59"
            clearable
          /> -->
          <el-date-picker
            v-model="listQuery.gmtModified"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" min-width="220" fixed="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="详情" placement="top">
            <vxe-button type="text" @click="handleClick(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>

          <el-tooltip
            v-if="scope.row.appealStatus == 4"
            class="item"
            effect="dark"
            content="重新申诉"
            placement="top"
          >
            <vxe-button type="text" @click="appealOrder(scope.row)">
              <!-- <em class="el-icon-refresh-right" /> -->
              <!-- <img src="@/assets/tms/cxsq.png" alt="" /> -->
              <img
                style="width: 13px; height: 13px;"
                src="@/assets/tms/cxsq.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.appealStatus == 1"
            class="item"
            effect="dark"
            content="申诉"
            placement="top"
          >
            <vxe-button type="text" @click="appealOrder(scope.row)">
              <img
                style="width: 13px; height: 13px;"
                src="@/assets/tms/shensu.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              scope.row.appealStatus == 2 ||
                scope.row.appealStatus == 4 ||
                scope.row.appealStatus == 5 ||
                scope.row.appealStatus == 3
            "
            class="item"
            effect="dark"
            content="申诉详情"
            placement="top"
          >
            <vxe-button type="text" @click="watchAppealOrder(scope.row)">
              <em class="el-icon-files" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              scope.row.appealStatus == 1 ||
                scope.row.appealStatus == 5 ||
                scope.row.appealStatus == 4
            "
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="delFunc(scope.row.code)">
              <em class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <!-- 不可申诉-重新申诉 -->
          <el-tooltip
            v-if="
              scope.row.appealStatus == 5 &&
                getLimit('abnormal_reloadAppeal_button')
            "
            class="item"
            effect="dark"
            content="重新申诉"
            placement="top"
          >
            <vxe-button type="text" @click="reopenAppealApi(scope.row.code)">
              <!-- <em class="el-icon-delete" /> -->
              <img
                style="width: 15px; height: 15px;display: inline-block;transform: translateY(3px)"
                src="@/assets/icon/reset.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="business"
      title="修改核算"
      width="860"
      height="auto"
      resize
    >
      <singledetails
        ref="businessRef"
        @event2="receive2"
        @handleCancel="handleCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="details"
      title="查看订单详情"
      width="1000"
      height="600"
      resize
    >
      <accounting
        v-if="details"
        ref="detailRef"
        :abnormal-type="true"
        @openMap="positionFunc"
      />
    </vxe-modal>
    <vxe-modal
      v-model="reject"
      title="请输入驳回理由"
      width="500"
      height="300"
      resize
    >
      <reject
        v-if="reject"
        ref="rejectRef"
        :message="parentMsg"
        @event1="receive"
      />
    </vxe-modal>
    <vxe-modal
      v-model="splitOrderFlag"
      title="子单详情"
      width="800"
      height="85%"
      resize
    >
      <splitOrder ref="splitOrderRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />

    <vxe-modal
      v-model="positionFlag"
      title="运单轨迹"
      width="88%"
      height="96%"
      resize
      remember
      @close="closePositionFunc"
    >
      <Position
        :key="timer"
        ref="positionRef"
        :order-code="code4OrderTrack"
        :positoin-info="positoinInfo"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
    <vxe-modal
      v-model="isAppealOrder"
      :title="alertType === 'detail' ? '申诉详情' : '运单申诉'"
      width="850px"
      height="750px"
      resize
      remember
      @close="closePositionFunc"
    >
      <appealOrder
        v-if="isAppealOrder"
        ref="positionRef"
        :appeal-info="appealInfo"
        :alert-type="alertType"
        @close="updateList"
      />
    </vxe-modal>
  </div>
</template>
<script>
import appealOrder from "./components/appealOrder.vue";
import {
  queryAbnormalOrderList,
  orderHandlePC,
  isOpenMaYi,
  reopenAppeal
} from "@/api/transport";
import singledetails from "./components/singledetails.vue";
import accounting from "@/components/WaybillDetails";
import reject from "./components/reject.vue";
import splitOrder from "@/views/tms/order/splitOrder";
import { getLimit } from "@/utils/getLimit.js";
import Position from "@/views/tms/transportManage/waybillManage/components/components/Position.vue";
import { deleteAbnormalOrderDetail } from "@/api/transport";
export default {
  components: {
    singledetails,
    accounting,
    reject,
    splitOrder,
    Position,
    appealOrder
  },
  props: {
    inAppealStatus: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      appealStatusOptions: [],
      optionsPickerEnd: {
        disabledDate: time => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() <
              new Date(this.form.lastLoadingTime).getTime() - 8.64e7
          );
        }
      },

      appealTypeOptions: [
        {
          label: "运费异常",
          value: "运费异常"
        },
        {
          label: "轨迹异常",
          value: "轨迹异常"
        },
        {
          label: "其他异常",
          value: "其他异常"
        }
      ],
      isAppealOrder: false,
      timer: "",
      code4OrderTrack: "",
      positoinInfo: {},
      positionFlag: false,
      exportObj: {
        exportUrl: "/ntocc-tms-api/orderDetail/exportDetailHandle", //导出接口
        name: "运费核算"
      },
      message: "",
      leitype: "",
      splitOrderFlag: false,
      business: false,
      details: false,
      reject: false,
      loading: false,
      freight_search_button: false, //查询
      freight_clearAll_button: false, //清除所有行选中
      freight_batchHandle_button: false, //批量核算
      freight_detail_button: false, //详情
      freight_reject_button: false, //驳回
      freight_edit_button: false, //编辑
      freight_splitOrder_button: false, //分单
      openMaYiBlockChain: false, //是否数据上链
      tableData: [],
      parentData: {
        isMonthlyOrderOptions: [],
        txStatusOptions: []
      },
      parentMsg: "",
      acclist: [],
      receiptOptions: [
        {
          value: "0",
          label: "未收取"
        },
        {
          value: "1",
          label: "已收取"
        }
      ],
      // 托运人类型
      shipmentOptions: [
        { label: "个体托运人", value: 0 },
        { label: "企业托运人", value: 1 }
      ],
      // 是否调单
      isTransferSearchOptions: [
        { value: 0, label: "否" },
        { value: 1, label: "是" }
      ],
      options: [
        {
          value: "1",
          label: "已接单"
        },
        {
          value: "2",
          label: "已装货"
        },
        {
          value: "3",
          label: "已卸货"
        },
        {
          value: "4",
          label: "已结算"
        },
        {
          value: "5",
          label: "已打款"
        }
      ],
      partyType: this.$store.getters.party.partyType,
      listQuery: {
        deleted: 0,
        orderGmtCreatedRange: [],
        gmtCreatedRange: "",
        lastLoadingTimeRange: "",
        fillTimeRange: "",
        lastUnloadingTimeRange: "",
        signTimeRange: "",
        gmtModifiedRange: "",
        rangeValue_start_1: "",
        rangeValue_end_1: "",
        rangeValue_start_2: "",
        rangeValue_end_2: "",
        rangeValue_start_3: "",
        rangeValue_end_3: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        lastUnloadingTimeStart: "",
        lastUnloadingTimeEnd: "",
        lastLoadingTimeStart: "",
        lastLoadingTimeEnd: "",
        gmtModifiedStart: "",
        gmtModifiedEnd: "",
        fillTimeStart: "",
        fillTimeEnd: "",
        signTimeStart: "",
        signTimeEnd: "",
        ordCreatedByName: ""
        // isUnloadingConfirm: 1
      },
      // Pagingconf: [],
      sumObject: {},
      isAdmin: false,
      isShipmentOrAdmin: false,
      isDriverOrAdmin: false,
      // 机构列表
      branchList: this.$store.state.components.branchList,
      isShowTxStatus: "",
      appealInfo: null,
      alertType: ""
    };
  },
  watch: {
    inAppealStatus: {
      handler(newVal, oldVal) {
        console.log("监听======", newVal);
        if (newVal) {
          // 0未申诉 1待申诉 2申诉中 3申诉成功 4申诉失败 5不可申诉
          if (newVal === "1,4") {
            this.appealStatusOptions = [
              {
                label: "待申诉",
                value: 1
              },
              {
                label: "申诉失败",
                value: 4
              }
            ];
          } else if (newVal === "3,5") {
            this.appealStatusOptions = [
              {
                label: "申诉成功",
                value: 3
              },

              {
                label: "不可申诉",
                value: 5
              }
            ];
          } else if (newVal === "2") {
            this.appealStatusOptions = [
              {
                label: "申诉中",
                value: 2
              }
            ];
          }
          this.findList();
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isAdmin = isAdmin;
    this.isShipmentOrAdmin =
      partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY" || isAdmin;
    this.isDriverOrAdmin =
      partyType == "DRIVER" || partyType == "DRIVER_LEADER" || isAdmin;
    this.parentData.isMonthlyOrderOptions = [
      { label: "次结", value: 0 },
      { label: "月结", value: 1 }
    ];
    this.parentData.txStatusOptions = [
      { label: "未上链", value: 0 },
      { label: "货源单上链", value: 1 },
      { label: "运单创建", value: 2 },
      { label: "运单启运", value: 3 },
      { label: "已上链", value: 4 },
      { label: "运单支付单创建", value: 5 },
      { label: "运单完成", value: 6 },
      { label: "运单关闭", value: 7 }
    ];

    // this.openMaYiBlockChain = dataBranch.partyGroupConfigCacheMap.MaYiBlockChainConfig_useMaYiCredit ? dataBranch.partyGroupConfigCacheMap.MaYiBlockChainConfig_useMaYiCredit.configValue == 1 : false;
    this.freight_search_button = getLimit("freight_search_button");
    this.freight_clearAll_button = getLimit("freight_clearAll_button");
    this.freight_batchHandle_button = getLimit("freight_batchHandle_button");
    this.freight_detail_button = getLimit("freight_detail_button");
    this.freight_reject_button = getLimit("freight_reject_button");
    this.freight_edit_button = getLimit("freight_edit_button");
    this.freight_splitOrder_button = getLimit("freight_splitOrder_button");
    this.getMaYiOpen();
  },
  methods: {
    reopenAppealApi(code) {
      this.$confirm("请确认是否重新申诉?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          reopenAppeal({ code }).then(res => {
            if (res.status === 0) {
              this.$message({
                type: "success",
                message: "重新申诉成功"
              });
              this.updateList();
            } else {
              this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    watchAppealOrder(obj) {
      this.alertType = "detail";
      this.isAppealOrder = true;
      this.appealInfo = obj;
    },
    updateList() {
      this.findList();
      this.isAppealOrder = false;
    },
    formatAppealStatus({ cellValue }) {
      console.log("formatAppealStatus========", cellValue);
      const item = this.appealStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },

    appealOrder(row) {
      this.appealInfo = row;
      this.alertType = "";

      this.isAppealOrder = true;
    },
    delFunc(code) {
      this.$confirm("请确认是否删除运单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const rLoading = this.openLoading();
          //setTimeout(() => {
          deleteAbnormalOrderDetail(code).then(response => {
            this.$message({
              type: "success",
              message: response.msg
            });
            this.findList();
            rLoading.close();
          });
          //}, 1000000);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    positionFunc(row, form) {
      const source = form || (row && typeof row === "object" ? row : {}) || {};
      this.positoinInfo = {
        vehicleLicense: source.vehicleLicense || source.licenseNumber || "",
        fillTime: source.fillTime || "",
        signTime: source.signTime || ""
      };
      this.timer = new Date().getTime();
      this.code4OrderTrack = row && typeof row === "object" ? row.code : row;
      this.positionFlag = true;
    },
    closePositionFunc() {
      this.$refs.positionRef.closeModal();
    },
    fatherSubmitFunc(modelFlag) {
      switch (modelFlag) {
        case "position":
          this.positionFlag = false;
          break;
        default:
      }
      this.findList();
    },
    fatherCancelFunc(modelFlag) {
      switch (modelFlag) {
        case "position":
          this.positionFlag = false;
          break;
        default:
      }
    },
    // add by JiaYK start 2021/10/23 13:19 区块链是否开启显示隐藏上链字段
    getMaYiOpen() {
      isOpenMaYi({ branchCode: this.$store.state.user.party.branchCode }).then(
        res => {
          this.isShowTxStatus = res.data;
        }
      );
    },
    // add by JiaYK end 2021/10/23 13:19 区块链是否开启显示隐藏上链字段
    receive(flag) {
      this.reject = false;
      if (flag) {
        this.findList();
      }
    },
    handleClick(c) {
      this.details = true;
      this.$nextTick(() => {
        this.$refs.detailRef.Getdetails(c, true);
        this.$refs.detailRef.queryOrderAppealListApi(c, true);
      });
    },
    // 驳回
    rejectClick(c) {
      this.reject = true;
      this.parentMsg = c;
    },
    //分单
    splitOrder(row) {
      this.$refs.splitOrderRef.findList(row);
      this.splitOrderFlag = true;
    },
    businessClick(c) {
      this.business = true;
      this.$refs.businessRef.shipmentlist(c);
    },
    receive2(c) {
      this.business = false;
      this.findList();
    },
    handleCancel() {
      this.business = false;
    },
    getSelectEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择需要结算项", type: "warning" });
      } else if (selectRecords.length > 100) {
        this.$message({ message: "批量处理最多100条数据", type: "warning" });
      } else {
        const rLoading = this.openLoading();
        const codes = selectRecords.map(item => item.code).join(",");
        orderHandlePC({ codes }).then(response => {
          rLoading.close();
          this.$message({
            message: response.data,
            type: "success"
          });
          this.findList();
        });
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        this.listQuery.inAppealStatus = this.inAppealStatus;
        let data = {
          ...this.listQuery
        };
        delete data.gmtModified;
        delete data.gmtCreated;
        queryAbnormalOrderList(data).then(response => {
          this.tableData = response.data.records;
          this.tableData.forEach(item => {
            item.taxPrice = item.taxPrice + item.isTrunkName;
            item.realPrice = item.realPrice + item.isTrunkName;
            item.coalPrice = item.coalPrice + "元/" + item.coalUnitName;
            item.maxPrice = item.maxPrice + item.isTrunkName;
            item.weight = item.weight + item.coalUnitName;
          });
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    formatterDriverNetFreight({ row }) {
      return row.deliveryFeePractical || "";
    },
    //状态翻译
    formatterReceiptStatus({ cellValue }) {
      switch (cellValue) {
        case "0":
          return "未收取";
        case "1":
          return "已收取";
        default:
          break;
      }
    },
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    /*
      footerCellClassName({ $rowIndex, column, columnIndex }) {
        if (columnIndex === 0) {
          if ($rowIndex === 0) {
            return 'col-blue'
          } else {
            return 'col-red'
          }
        }
      }, */
    headerCellClassName({ column, columnIndex }) {
      if (column.property === "name") {
        return "col-blue";
      }
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      if (column.property === "status") {
        switch (row.status) {
          case 0:
            return "col-red";
          case 1:
            return "col-green";
          case 2:
            return "col-orange";
          case 3:
            return "col-red";
          case 4:
            return "col-green";
          case 5:
            return "col-orange";

          default:
            break;
        }
      }
    },
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item1 => item1.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterStatus({ cellValue }) {
      switch (cellValue) {
        case 1:
          return "已接单";
        case 2:
          return "已装货";
        case 3:
          return "已卸货";
        case 4:
          return "已结算";
        case 5:
          return "已打款";

        default:
          break;
      }
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (
            [
              "shipmentActualFreight",
              "driverActualFreight",
              "payTaxAmount",
              "platformPrepayment",
              "shipmentActualCash",
              "driverActualCash",
              "shipmentDeliveryFeePractical",
              "platformPrepayment",
              "driverActualCash",
              "extraFee",
              "abnormalFee",
              "payOil",
              "payAmount",
              "allotOil"
            ].includes(column.property)
          ) {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "shipperDeliveryFee") {
            return this.sumObject.shipperDeliveryFee;
          }
          if (column.property === "deliveryFeePractical") {
            return this.sumObject.deliveryFeePractical;
          }
          if (column.property === "deliveryCashFee") {
            return this.sumObject.deliveryCashFee;
          }
          if (column.property === "taxFee") {
            return this.sumObject.taxFee;
          }
          if (column.property === "taxPayFee") {
            return this.sumObject.taxPayFee;
          }
          if (column.property === "distance") {
            return this.sumObject.distance;
          }
          if (column.property === "deliveryOilFee") {
            return this.sumObject.deliveryOilFee;
          }
          if (column.property === "deliveryFeeDeserved") {
            return this.sumObject.deliveryFeeDeserved;
          }
          if (column.property === "weight") {
            return (
              this.sumObject.ton +
              "吨//" +
              this.sumObject.cubicMeter +
              "方//" +
              this.sumObject.pieces +
              "件"
            );
          }
          if (column.property === "wastage") {
            return (
              this.sumObject.wastageTon +
              "吨//" +
              this.sumObject.wastageCubicMeter +
              "方//" +
              this.sumObject.wastagePieces +
              "件"
            );
          }
          if (column.property === "loadQuantity") {
            return (
              this.sumObject.loadQuantityTon +
              "吨//" +
              this.sumObject.loadQuantityCubicMeter +
              "方//" +
              this.sumObject.loadQuantityPieces +
              "件"
            );
          }
          if (column.property === "unloadQuantity") {
            return (
              this.sumObject.unloadQuantityTon +
              "吨//" +
              this.sumObject.unloadQuantityCubicMeter +
              "方//" +
              this.sumObject.unloadQuantityPieces +
              "件"
            );
          }
          if (column.property === "settlementWeight") {
            return (
              this.sumObject.settlementWeightTon +
              "吨//" +
              this.sumObject.settlementWeightCubicMeter +
              "方//" +
              this.sumObject.settlementWeightPieces +
              "件"
            );
          }
          if (column.property === "extraFee") {
            return this.sumObject.extraFee;
          }
          return "-";
        })
      ];
    }
  }
};
</script>
<style>
.checkbox-table.vxe-table .vxe-body--row.row-checked {
  background-color: #fbf8ec;
}
.vxe-footer--row .col-blue {
  background-color: rgb(233, 20, 20);
  color: #fff;
}
.vxe-footer--row .col-red {
  background-color: rgb(32, 11, 219);
  color: #fff;
}
.mytable-footer .vxe-body--row.row-green {
  background-color: #187;
  color: #2db7f5;
}
.mytable-footer .vxe-header--column.col-blue {
  background-color: #2db7f5;
  color: #fff;
}
.mytable-footer .vxe-body--column.col-red {
  color: #f00;
}
.mytable-footer .vxe-body--column.col-orange {
  color: #f60;
}
.mytable-footer .vxe-body--column.col-green {
  color: rgb(29, 47, 202);
}
</style>
